import { TableColumn } from "../../../../components/ModularDataTable"


function StatusTablePluginspace({ row }: { row: any }) {
    const statusMap: Record<string, { text: string; color: string; background: string }> = {
        true: { text: 'Ativo', color: 'green', background: 'rgba(0, 128, 0, 0.3)' },
        false: { text: 'Inativo', color: 'red', background: 'rgba(255, 0, 0, 0.3)' },
    }
    const statusInfo = statusMap[row.status] || { text: row.status, color: 'gray', background: 'rgba(128, 128, 128, 0.1)' }
    return (
        <div><span className='py-1 rounded px-2' style={{ background: statusInfo.background, color: statusInfo.color, fontWeight: 'bold' }}>{statusInfo.text}</span></div>
    )
}

export function generateColumnsPluginSpace(): TableColumn[] {

    const columns: TableColumn[] = [
        { key: 'Tipo', value: 'type', type: 'text' },
        { key: 'Id', value: 'id', type: 'text' },
        { key: 'Nome', value: 'name', type: 'text' },
        { key: 'Subdomínio', value: 'subdomain', type: 'text' },
        {
            key: 'Status',
            value: 'status',
            type: 'custom',
            render: (value: any, row: any) => (<StatusTablePluginspace row={row} />)
        },
        { key: 'Criado em', value: 'created', type: 'datetime' },
        { key: 'CNPJ', value: 'cnpj', type: 'text' },
    ]



    return columns
}